import { styled } from '@mui/material/styles';
import type { OverflowProps } from '../Overflow';
import { Overflow } from '../Overflow';

const MuiOverflow: React.ComponentType<OverflowProps> = styled(Overflow)({});

export default MuiOverflow;
